<template>
  <v-combobox
    :value="selectedItem"
    @input="onInput"
    v-bind="$attrs"
    v-on="$listeners"
    :loading="loading"
    :items="items"
    :search-input.sync="search"
    hide-no-data
    item-value="id"
    :item-text="itemText"
    clearable
    multiple
    return-object
    no-filter
    ref="combobox"
    v-if="reload"
  >
    <template v-if="showKey == true" v-slot:selection="data">
      {{ data.item.fullName }} - {{ data.item.participantKey }}<br />
    </template>
    <template v-slot:append-item>
      <v-list-item disabled v-if="showBottomMessage">
        <v-list-item-content>
          <v-list-item-title>
            Type to filter more records...
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item></template
    >
  </v-combobox>
</template>

<script>
import ApiService from "../../services/api.service";

export default {
  name: "ParticipantsField",
  props: {
    value: Array,
    preventIds: Array,
    typeKey: String,
    showKey: {
      type: Boolean,
      default: false,
      required: false
    },
    organization: {
      type: Object,
      default: null
    },
    status: { type: String, required: false }
  },
  data: () => ({
    showBottomMessage: true,
    selectedItem: {},
    loading: false,
    search: null,
    items: [],
    rules: [
      v => {
        if (!!v && !v.id) {
          return "Invalid selection";
        } else {
          return true;
        }
      }
    ],
    reload: true
  }),
  methods: {
    onInput(obj) {
      if (obj && obj.id) {
        this.$emit("input", obj);
      }
    },
    clear() {
      this.reload = false;
      this.$nextTick(() => {
        this.reload = true;
      });
    },
    itemText(item) {
      return this.showKey ? item.fullName + " - " + item.participantKey : item.fullName;
    }
  },
  watch: {
    search(val) {
      if (this.loading) {
        return;
      }
      this.loading = true;
      let filters = {};
      filters.keyword = val;
      filters.isEffective = this.status;

      if (this.organization) {
        filters.organization = { id: this.organization.id };
      }
      ApiService.post("/api/participants/search", filters).then(({ data }) => {
        let fullItems = data.content;
        if (this.preventIds && this.preventIds.length > 0) {
          fullItems = fullItems.reduce((acc, cur) => {
            if (this.preventIds.indexOf(cur.id) == -1) {
              acc.push(cur);
            }
            return acc;
          }, []);
        }
        if (fullItems.length > 9) {
          this.items = fullItems.slice(0, 9);
          this.showBottomMessage = true;
        } else {
          this.items = fullItems;
          this.showBottomMessage = false;
        }
        this.loading = false;
      });
    },
    value: {
      deep: true,
      immediate: true,
      handler() {
        this.$set(this, "selectedItem", this.value);
      }
    }
  },
  mounted() {
    this.selectedItem = this.value;
    this.search = "";
  }
};
</script>
